import React from "react";
import { useAuth } from "../lib/auth";
import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { toast } from "sonner";

export default function Settings() {
  const { user, tenant, logout } = useAuth();
  const { data: agents = [] } = useQuery({ queryKey: ["agents"], queryFn: () => api.get("/agents").then(r => r.data) });
  const teamCount = new Set(agents.map(a => a.team)).size;

  return (
    <div className="min-h-screen">
      <div className="border-b border-[#141414] px-8 py-5 sticky top-0 bg-[#050505]/90 backdrop-blur-md z-20">
        <div className="font-mono text-[10px] uppercase tracking-widest text-[#52525B]">// Settings</div>
        <h1 className="font-display font-bold text-2xl">Workspace configuration</h1>
      </div>
      <div className="p-8 grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-5xl">
        <div className="border border-[#171717] bg-[#0a0a0a] p-6">
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#52525B] mb-2">// Tenant</div>
          <div className="font-display font-bold text-2xl mb-3">{tenant?.name}</div>
          <dl className="space-y-2 text-sm">
            <div className="flex justify-between border-b border-[#141414] py-2"><dt className="text-[#A1A1AA]">Tenant ID</dt><dd className="font-mono text-xs">{tenant?.id}</dd></div>
            <div className="flex justify-between border-b border-[#141414] py-2"><dt className="text-[#A1A1AA]">Slug</dt><dd className="font-mono text-xs">{tenant?.slug}</dd></div>
            <div className="flex justify-between border-b border-[#141414] py-2"><dt className="text-[#A1A1AA]">Plan</dt><dd className="font-mono text-xs uppercase text-[#F5A524]">{tenant?.plan}</dd></div>
            <div className="flex justify-between border-b border-[#141414] py-2"><dt className="text-[#A1A1AA]">Primary color</dt><dd className="flex items-center gap-2 font-mono text-xs"><span className="w-4 h-4 border border-[#222]" style={{ background: tenant?.brand_color }} /> {tenant?.brand_color}</dd></div>
            <div className="flex justify-between py-2"><dt className="text-[#A1A1AA]">Accent</dt><dd className="flex items-center gap-2 font-mono text-xs"><span className="w-4 h-4 border border-[#222]" style={{ background: tenant?.accent_color }} /> {tenant?.accent_color}</dd></div>
          </dl>
        </div>

        <div className="border border-[#171717] bg-[#0a0a0a] p-6">
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#52525B] mb-2">// Signed in user</div>
          <div className="font-display font-bold text-2xl mb-3">{user?.name}</div>
          <dl className="space-y-2 text-sm">
            <div className="flex justify-between border-b border-[#141414] py-2"><dt className="text-[#A1A1AA]">Email</dt><dd className="font-mono text-xs">{user?.email}</dd></div>
            <div className="flex justify-between border-b border-[#141414] py-2"><dt className="text-[#A1A1AA]">Role</dt><dd className="font-mono text-xs uppercase">{user?.role}</dd></div>
            <div className="flex justify-between py-2"><dt className="text-[#A1A1AA]">User ID</dt><dd className="font-mono text-xs">{user?.id}</dd></div>
          </dl>
          <Button data-testid="settings-logout" onClick={() => { logout(); toast.success("Signed out"); window.location.href = "/login"; }} variant="outline" className="mt-4 border-[#F31260]/40 text-[#F31260] hover:bg-[#F31260]/10 hover:text-[#F31260] rounded-sm">
            Sign out
          </Button>
        </div>

        <div className="lg:col-span-2 border border-[#171717] bg-[#0a0a0a] p-6">
          <div className="font-mono text-[10px] uppercase tracking-widest text-[#52525B] mb-2">// Provider gateway</div>
          <div className="font-display font-bold text-2xl mb-4">Private model routing</div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            <div className="p-4 border border-[#171717]">
              <div className="font-mono text-[9px] uppercase tracking-widest text-[#F5A524]">TEXT · REASONING</div>
              <div className="font-display font-bold mt-1">Claude Sonnet 4.5</div>
              <div className="text-xs text-[#A1A1AA] mt-1">Primary agent brain. Private routing.</div>
            </div>
            <div className="p-4 border border-[#171717]">
              <div className="font-mono text-[9px] uppercase tracking-widest text-[#00F0FF]">IMAGE</div>
              <div className="font-display font-bold mt-1">Nano Banana</div>
              <div className="text-xs text-[#A1A1AA] mt-1">Storyboard + character rendering.</div>
            </div>
            <div className="p-4 border border-[#171717]">
              <div className="font-mono text-[9px] uppercase tracking-widest text-[#17C964]">AGENT FLEET</div>
              <div className="font-display font-bold mt-1">{agents.length} agents · {teamCount} teams</div>
              <div className="text-xs text-[#A1A1AA] mt-1">Global registry seeded.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
